export default __webpack_public_path__ + "static/img_interviewee_jelee-c1397cc470424bf484e8c9d76cd6b54b.png";